/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/**
 * Sprint 1 — Predictive AI Triage (conversational Claude) + Live Transcription client.
 */

// ---- Triage ----
export async function createTriageSession({ reason, age, sex, appointment_id } = {}) {
  const res = await api.post('/triage/session', { reason, age, sex, appointment_id });
  return res.data;
}

export async function sendTriageMessage(sessionId, message) {
  const res = await api.post(`/triage/session/${sessionId}/message`, { message });
  return res.data;
}

export async function finalizeTriageSession(sessionId) {
  const res = await api.post(`/triage/session/${sessionId}/finalize`);
  return res.data;
}

export async function getTriageSession(sessionId) {
  const res = await api.get(`/triage/session/${sessionId}`);
  return res.data;
}

// ---- Transcription ----
export async function saveTranscriptChunk({ appointment_id, text, speaker, started_at_ms, ended_at_ms, is_final = true }) {
  const res = await api.post('/transcription/save', {
    appointment_id,
    text,
    speaker: speaker || 'unknown',
    started_at_ms,
    ended_at_ms,
    is_final,
  });
  return res.data;
}

export async function getTranscript(appointmentId) {
  const res = await api.get(`/transcription/appointment/${appointmentId}`);
  return res.data;
}

export async function generateSoapFromTranscript(appointmentId, additional_context) {
  const res = await api.post('/transcription/generate-soap', {
    appointment_id: appointmentId,
    additional_context: additional_context || undefined,
  });
  return res.data;
}
